import Header from './Header';
import FeaturedPosts from './FeaturedPosts';
import AuthButtons from './AuthButtons';
import PushNotifications from './push-notifications';

export default {
  Header,
  FeaturedPosts,
  AuthButtons,
  PushNotifications,
};
